/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable no-loop-func */
/* eslint-disable no-unused-expressions */
import axios from 'axios';
import qs from 'qs';
import {
  getCacheUserInfo,
  getToken,
  removeToken
} from '@/utils/auth';

let Vue;
// 默认请求路径
// axios.defaults.baseURL = '/';

// 超时时间
axios.defaults.timeout = 10000;

axios.defaults.withCredentials = true;

axios.defaults.crossDomain = true;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 在此处可以进行请求头的设置
axios.interceptors.request.use((config) => config, (err) => Promise.error(err));

// eslint-disable-next-line no-unused-vars
const httpRetry = {
  retryQueue: [],
  hasMore() {
    return this.retryQueue.length > 0;
  },
  pushRetry(config) {
    const retryItem = {
      key: config,
      retry() {
        return axios.request(config);
      },
      resolve: null,
      reject: null,
    };
    this.retryQueue.push(retryItem);
  },
  retry() {
    // const promises = [];
    let retryItem = null;
    while (this.hasMore()) {
      retryItem = this.retryQueue.shift();
      retryItem.retry().then((res) => {
        retryItem.resolve && retryItem.resolve(res.data, res);
      }, (err) => {
        retryItem.reject && retryItem.reject(err, err);
      });
    }
  },
};

axios.interceptors.response.use((response) => {
  console.log("response----------",response)
  if (response.status === 200) {
    if(response.data.code===9001){
      window.localStorage.removeItem('userInfo');
      removeToken()
      // window.location.reload();
      return
    }
  }

  /* if (response.status === 200) {
    if (response.data.code === 1001) {
      httpRetry.pushRetry(response.config);
      return Promise.reject(response);
    }
    return Promise.resolve(response);
  } if (response.status === 401) {
    // 缓存之前的请求
    if (response.config) {
      httpRetry.pushRetry(response.config);
    }
    return Promise.reject(response);
  } */
  return Promise.resolve(response);
}, (err) => {
  // 响应状态码不是200的时候进行判断
  // 缓存之前的请求`
  /* if (err && err.status === 401 && err.config) {
    httpRetry.pushRetry(err.config);
  }
  if (err && err.response && err.response.status === 401 && err.response.config) {
    httpRetry.pushRetry(err.response.config);
    return Promise.reject(err.response);
  } */
  return Promise.reject(err);
});

const login = (res, resolve, reject) => {
  if ((res.status === 401 || res.data.code === 1002) || (res.status === 200 && res.data.code === 1001)) {
    httpRetry.retryQueue && httpRetry.retryQueue.forEach((q) => {
      if (q.key === res.config) {
        q.resolve = resolve;
        q.reject = reject;
      }
    });
    return Promise.resolve();
  }
};

export default {
  install(_Vue) {
    Vue = _Vue;
    Vue.prototype.$http = {
      get(url, params, headers = {}) {
        return new Promise((resolve, reject) => {
          let defaultHeaders = {
            uid: getCacheUserInfo().uid,
          }
          console.log("url--",url)
          if (url.indexOf("opapi/") < 0) {
            defaultHeaders.Authorization = getToken()
          }
          axios.get(url, {
            params,
            headers: Object.assign(defaultHeaders, headers),
          }).then((res) => {
            resolve(res.data, res);
          }, (res) => login(res, resolve, reject)).catch((err) => reject(err.data, err));
        });
      },
      // 简单请求， 会把请求参数设置为字符串
      post(url, params, headers = {}) {
        let defaultHeaders = {
          uid: getCacheUserInfo().uid,
        }
        if (url.indexOf("opapi/") < 0) {
          defaultHeaders.Authorization = getToken()
        }
        return new Promise((resolve, reject) => {
          axios.post(url, qs.stringify(params, {
              indices: false
            }), {
              headers: Object.assign(defaultHeaders, headers),
            })
            .then((res) => {
              resolve(res.data, res);
            }, (res) => {
              // login(res, resolve, reject);
              reject(res.data, res);
            })
            .catch((err) => {
              reject(err.data, err);
            });
        });
      },
      apost(url, params, headers = {}) {
        let defaultHeaders = {
          uid: getCacheUserInfo().uid,
        }
        if (url.indexOf("opapi/") < 0) {
          defaultHeaders.Authorization = getToken()
        }
        return new Promise((resolve, reject) => {
          axios.post(url, qs.stringify(params, {
              indices: false
            }), {
              headers: Object.assign(defaultHeaders, headers),
            })
            .then((res) => {
              resolve(res.data, res);
            }, (res) => {
              login(res, resolve, reject);
            })
            .catch((err) => {
              reject(err.data, err);
            });
        });
      },
    };
  },
};
